<template lang="pug">
  #app(v-if="user.user_nicename")
    #loading(v-if="isLoading")
      orbit-spinner(
        :animation-duration="1200"
        :size="55"
        color="#24890d"
      )

    h1 Ansergy Email Reports
    h3 {{ user.user_nicename }}
    br

    report-template-list
  #loading(v-else)
    h4 Loading ...
    orbit-spinner(
        :animation-duration="1200"
        :size="55"
        color="#24890d"
      )
</template>

<script>
import { mapState, mapActions } from 'vuex'
import vueMultiselect from 'vue-multiselect'
import Vue from 'vue'
import VueTabs from 'vue-nav-tabs'
import reportList from '@/components/report-list'
import { OrbitSpinner } from 'epic-spinners'
import allReports from '@/components/all-reports'
import reportTemplateList from '@/components/report-template-list'

Vue.use(VueTabs)

export default {
  name: 'app',
  components: { vueMultiselect, reportList, reportTemplateList, allReports, OrbitSpinner },
  computed: {
    ...mapState(['isAdmin', 'isLoading', 'user'])
  },
  methods: {
    ...mapActions(['getAppState'])
  },
  mounted () {
    this.getAppState()
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="stylus">

#app {
  width: 1180px
  max-width: 100%
  margin: 0em auto
  padding: 2em 1em
}

#loading {
  position: fixed
  z-index: 99999
  top: 0
  left: 0
  right: 0
  bottom: 0
  background: rgba(white, .75)
  pointer-events: none
  display: flex
  justify-content: center
  align-items: center
  flex-direction: column
}

table {
  width: 100%
}

html h2 {
  margin: 0 auto .5em
}

button {
  cursor: pointer
}

.tab-content {
  padding: 1em
}

</style>



// WEBPACK FOOTER //
// App.vue?a7c25fac